import { render, staticRenderFns } from "./reaFail.vue?vue&type=template&id=faffd830&scoped=true&"
import script from "./reaFail.vue?vue&type=script&lang=js&"
export * from "./reaFail.vue?vue&type=script&lang=js&"
import style0 from "./reaFail.vue?vue&type=style&index=0&id=faffd830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faffd830",
  null
  
)

export default component.exports